import React from "react";

const Pending = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className='u_fill'
            fill={fill}
            d="M19.6 3.6a1.6 1.6 0 1 0-3.2 0v4.8a1.6 1.6 0 1 0 3.2 0V3.6ZM29.371 8.891A1.6 1.6 0 0 0 27.11 6.63l-3.44 3.44a1.6 1.6 0 0 0 2.262 2.262l3.44-3.44ZM26 18a1.6 1.6 0 0 1 1.6-1.6h4.8a1.6 1.6 0 1 1 0 3.2h-4.8A1.6 1.6 0 0 1 26 18ZM25.931 23.669a1.6 1.6 0 0 0-2.262 2.262l3.44 3.44a1.6 1.6 0 0 0 2.262-2.262l-3.44-3.44ZM18 26a1.6 1.6 0 0 1 1.6 1.6v4.8a1.6 1.6 0 1 1-3.2 0v-4.8A1.6 1.6 0 0 1 18 26ZM12.331 25.931a1.6 1.6 0 1 0-2.262-2.262l-3.44 3.44A1.6 1.6 0 0 0 8.89 29.37l3.44-3.44ZM2 18a1.6 1.6 0 0 1 1.6-1.6h4.8a1.6 1.6 0 1 1 0 3.2H3.6A1.6 1.6 0 0 1 2 18ZM8.891 6.629A1.6 1.6 0 1 0 6.63 8.89l3.44 3.44a1.6 1.6 0 0 0 2.262-2.262l-3.44-3.44Z"
        />
    </svg>
);

export default Pending;